export default "__VITE_ASSET__D$xuczHd__"